// Config for the flat (no-subcategory-split) CMS service categories, each
// rendered by the generic CategoryHub / CategoryServiceDetail pages.
//
// `parent` mirrors where the category sits in the navbar (see NAV_MEGA in
// data.js). These two are nav sub-categories rather than top-level items, so
// their hubs and detail pages show the parent in the breadcrumb, and the
// parent's hub links down to them. Keep the two in sync — the navbar is the
// source of truth for the hierarchy.
export const CATEGORY_CONFIG = {
  "business-licences": {
    dbCategory: "Business Licences",
    label: "Business Licences",
    tagline: "Udyam, FSSAI, IEC and Shop Act — the licences your business runs on.",
    accentKey: "gold",
    contactService: "Business Licences",
    parent: { label: "Registration", href: "/registration" },
  },
  "accounting-finance": {
    dbCategory: "Account & Finance",
    label: "Accounting & Finance",
    tagline: "Bookkeeping, MIS, Virtual CFO and financial planning, handled end to end.",
    accentKey: "emerald",
    contactService: "Accounting & Finance",
    parent: { label: "Compliance", href: "/compliance" },
  },
  "other-services": {
    dbCategory: "Other Services",
    label: "Other Services",
    tagline: "Audit support, MSME and startup advisory, funding and structuring — everything else your business needs.",
    accentKey: "gold",
    contactService: "Other Services",
  },
};

// Categories that hang off `parentHref` in the navbar — used by the parent's
// hub page to link down, instead of duplicating the child's service cards.
export const childCategoriesOf = (parentHref) =>
  Object.entries(CATEGORY_CONFIG)
    .filter(([, c]) => c.parent?.href === parentHref)
    .map(([slug, c]) => ({ slug, ...c }));
